export const SCRIPT_ADDRESS_TESTNET =
  'addr1vyaqlhtgq2fnrcttnqejddzaswanahr6lc20f05dua2vaxq78guu9'

export const CARDANO_EXPLORER_TESTNET =
  'https://explorer.mainnet.cardano.org/en/transaction?id='
